import { selectorForSlice, setState } from 'lp-redux-utils';
import { handleActions } from 'redux-actions';
import * as actions from './actions';
const reducerKey = 'flexFinalize';
const slice = 'root.creditPortal.flexFinalize';
const initialState = {
    authorizationToken: '',
    instrumentId: null,
    bankAccounts: [],
    selectedBankAccount: null,
    lenderAccountIdentifier: null,
    autopayCompleted: false,
    signingUrl: null,
    financialStatus: null,
    paymentOption: null,
};
const reducer = handleActions({
    [actions.setAuthorizationToken.toString()]: setState('authorizationToken'),
    [actions.setInstrumentId.toString()]: setState('instrumentId'),
    [actions.setLenderAccountIdentifier.toString()]: setState('lenderAccountIdentifier'),
    [actions.setAutopayCompleted.toString()]: setState('autopayCompleted'),
    [actions.setBankAccounts.toString()]: setState('bankAccounts'),
    [actions.setSelectedBankAccount.toString()]: setState('selectedBankAccount'),
    [actions.setSigningUrl.toString()]: setState('signingUrl'),
    [actions.setFinancialStatus.toString()]: setState('financialStatus'),
    [actions.setPaymentOption.toString()]: setState('paymentOption'),
    [actions.clearFlexFinalizeData.toString()]: () => initialState,
}, initialState);
const select = selectorForSlice(slice);
const selectors = {
    authorizationToken: select('authorizationToken'),
    instrumentId: select('instrumentId'),
    lenderAccountIdentifier: select('lenderAccountIdentifier'),
    autopayCompleted: select('autopayCompleted'),
    bankAccounts: select('bankAccounts'),
    selectedBankAccount: select('selectedBankAccount'),
    signingUrl: select('signingUrl'),
    financialStatus: select('financialStatus'),
    paymentOption: select('paymentOption'),
};
export { reducer, selectors, reducerKey };
